import React from 'react';
import { 
  Users, Box, TrendingUp, CheckCircle2, 
  Camera, Briefcase, ShieldCheck, Zap, 
  ArrowRight, FileText, Layout, ArrowDown, Wallet
} from 'lucide-react';

export default function MbogiCapitalPage() {
  return (
    <div className="bg-white font-sans text-slate-900 overflow-x-hidden">
      
    

      {/* --- WHO IS IT FOR / SMART CONTRACTS --- */}
      <section className="py-10 px-6 max-w-7xl mx-auto">
        <h2 className="text-center text-3xl md:text-5xl font-bold mb-16">Smart Contract Ecosystem</h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-20">
          {/* Creator Box */}
          <div className="bg-slate-900 text-white p-10 rounded-[2.5rem] relative overflow-hidden group">
            <Camera className="absolute top-8 right-8 text-slate-700 w-12 h-12" />
            <h3 className="text-2xl font-bold mb-4">For Creators</h3>
            <p className="text-slate-400 mb-8">Producers, Storytellers, and Crew. Access global capital without geographical barriers.</p>
            <ul className="space-y-3 mb-10">
              <li className="flex items-center gap-2 text-sm text-slate-300"><CheckCircle2 className="w-4 h-4 text-orange-400" /> Verified Skill-Equity tracking</li>
              <li className="flex items-center gap-2 text-sm text-slate-300"><CheckCircle2 className="w-4 h-4 text-orange-400" /> Instant production budget access</li>
            </ul>
            <button className="w-full py-4 border border-slate-700 rounded-xl hover:bg-slate-800 transition-colors font-bold">
              Register as Creator
            </button>
          </div>

          {/* Investor Box */}
          <div className="bg-[#c07d3e] text-white p-10 rounded-[2.5rem] relative overflow-hidden shadow-xl">
            <Briefcase className="absolute top-8 right-8 text-orange-300/30 w-12 h-12" />
            <h3 className="text-2xl font-bold mb-4">For Investors</h3>
            <p className="text-orange-100/80 mb-8">Gain direct ownership of film IPs and enjoy transparent, automated ROI via smart contracts.</p>
            <ul className="space-y-3 mb-10">
              <li className="flex items-center gap-2 text-sm text-orange-50"><CheckCircle2 className="w-4 h-4 text-white" /> On-chain proof of ownership</li>
              <li className="flex items-center gap-2 text-sm text-orange-50"><CheckCircle2 className="w-4 h-4 text-white" /> Automated dividends & exits</li>
            </ul>
            <button className="w-full py-4 bg-white text-[#c07d3e] rounded-xl hover:bg-orange-50 transition-colors font-bold shadow-lg">
              Start Investing
            </button>
          </div>
        </div>

        {/* REDEFINING SKILL EQUITY */}
   <div className="bg-white rounded-[3rem] p-8 md:p-16 flex flex-col lg:flex-row items-center gap-16 border border-slate-100 shadow-sm">
  <div className="flex-1">
    <span className="bg-orange-100 text-[#c07d3e] px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest">
      Fair Compensation
    </span>
    <h2 className="text-3xl md:text-4xl font-extrabold mt-6 mb-6 leading-tight text-[#0a1d2e]">
      Turn Your Work into <span className="text-[#c07d3e]">Wealth.</span>
    </h2>
    <p className="text-slate-500 text-lg leading-relaxed mb-8">
      In the old world, you get a paycheck and walk away. At Mbogi, your hours on set become <strong>permanent ownership</strong> in the film.
    </p>
    
    <div className="space-y-4">
      {[
        { 
          title: "You contribute your talent", 
          desc: "Log your hours or bring your gear to the production." 
        },
        { 
          title: "The system secures your stake", 
          desc: "Our technology automatically calculates your percentage of the film's success." 
        },
        { 
          title: "You earn for a lifetime", 
          desc: "When the movie makes money on Netflix or in theaters, you get paid directly." 
        }
      ].map((item, i) => (
        <div key={i} className="flex gap-4">
          <div className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-500 text-white flex items-center justify-center text-xs font-bold">
            {i + 1}
          </div>
          <div>
            <p className="font-bold text-[#0a1d2e]">{item.title}</p>
            <p className="text-sm text-slate-400">{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>

  {/* THE "EQUITY FACTORY" VISUAL - USER FRIENDLY VERSION */}
  <div className="flex-1 w-full bg-slate-50 rounded-[3rem] p-10 relative border border-slate-100 shadow-inner">
    <div className="flex flex-col items-center gap-8 relative z-10">
      
      {/* Step 1: Human Input */}
      <div className="w-full bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex items-center gap-5 transition-transform hover:scale-105">
        <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600">
          <Camera className="w-6 h-6" />
        </div>
        <div>
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Step 1</p>
          <p className="font-extrabold text-[#0a1d2e]">10 Days on Set</p>
        </div>
        <div className="ml-auto bg-blue-100 text-blue-700 text-[10px] font-bold px-2 py-1 rounded">WORK LOGGED</div>
      </div>

      {/* Connection Arrow */}
      <ArrowDown className="text-slate-200 w-8 h-8 animate-bounce" />

      {/* Step 2: The "Magic" Conversion */}
      <div className="w-full bg-[#c07d3e] p-8 rounded-[2rem] shadow-xl text-center text-white relative overflow-hidden group">
        <div className="relative z-10">
           <Zap className="w-8 h-8 mx-auto mb-3 text-orange-200" />
           <p className="text-xl font-black mb-1">Mbogi Protocol</p>
           <p className="text-sm opacity-80">Converting Skill to Ownership...</p>
        </div>
        {/* Animated background pulse */}
        <div className="absolute inset-0 bg-white/10 scale-0 group-hover:scale-150 transition-transform duration-1000 rounded-full blur-3xl"></div>
      </div>

      {/* Connection Arrow */}
      <ArrowDown className="text-slate-200 w-8 h-8" />

      {/* Step 3: Ownership Result */}
      <div className="w-full bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex items-center gap-5 transition-transform hover:scale-105">
        <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center text-green-600">
          <Wallet className="w-6 h-6" />
        </div>
        <div>
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Step 3</p>
          <p className="font-extrabold text-[#0a1d2e]">0.5% Lifetime Equity</p>
        </div>
        <CheckCircle2 className="ml-auto w-6 h-6 text-green-500" />
      </div>

    </div>

    {/* Background Decoration */}
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-orange-200/20 blur-[100px] rounded-full"></div>
  </div>
</div>
      </section>

      {/* --- CTA SECTION --- */}
      <section className="bg-white py-10 text-center px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-8">Ready to join the ecosystem?</h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-[#c07d3e] text-white px-10 py-4 rounded-2xl font-bold flex items-center justify-center gap-2 hover:bg-[#a66b34] transition-all shadow-xl shadow-orange-100">
              Launch App <ArrowRight className="w-5 h-5" />
            </button>
            <button className="bg-slate-100 text-slate-700 px-10 py-4 rounded-2xl font-bold flex items-center justify-center gap-2 hover:bg-slate-200 transition-all">
              <FileText className="w-5 h-5" /> Read Whitepaper
            </button>
          </div>
        </div>
      </section>

      {/* Footer minimal */}
     
    </div>
  );
}